import styles from './index.module.scss';
import { Spin } from 'antd';

// eslint-disable-next-line react/display-name
export default ()=>{
    return (
        <div className={styles.page}>
            <Spin />
        </div>
    )
}